const openEditMessage = (state, action) => ({
  ...state,
  currentlyEditedMessageId: action.payload.messageId,
});

export default openEditMessage;
